export const getSubdomain = (): string | null => {
  try {
    const { hostname } = new URL(window.location.href);

    // 🔒 Localhost handling
    if (hostname === 'localhost') return null;

    if (hostname.endsWith('.localhost')) {
      const sub = hostname.replace('.localhost', '');
      return sub && sub !== 'localhost' ? sub : null;
    }

    const parts = hostname.split('.');

    // Remove 'www' if present at the start
    if (parts[0].toLowerCase() === 'www') {
      parts.shift();
    }

    // e.g. dawagpt.com → no subdomain
    if (parts.length <= 2) return null;

    return parts[0];
  } catch (err) {
    console.error('Error extracting subdomain:', err);
    return null;
  }
};

export const isSaaSSubdomain = () => {
  const subdomain = getSubdomain();
  if (!subdomain) return true; // Treat no subdomain as SaaS for local development
  return subdomain === process.env.REACT_APP_SAAS_SUBDOMAIN;
};
